/**
 * 全局的常量对象，提供组件与store的通信
 */
const state = {
  userInfo: {},
  deviceInfo: {},
  showDialog: false,
  loading: false,

  children: [],
  childId: '',
  isWxConfigRegister: false
};

export default state;
